import CheckInput from './components/CheckInput';
import React, { useState } from 'react';
import ErrorPanel from './components/ErrorMessage';
import { useFormContext } from 'react-hook-form';
import clsx from 'clsx';
import CustomScroll from './components/CustomScroll';
const Step3 = () => {
    const OutputData = [
        { key: ".rtv", name: "rvt", description: "RVT File" },
        { key: ".dwg", name: "dwg", description: "DWG File" },
        { key: ".jpg", name: "jpg", description: "Jpeg File" },
        { key: ".ifc", name: "ifc", description: "IFC File" },
        { key: ".pdf", name: "pdf", description: "PDF File" },
        { key: "other", name: "other", description: "Other File Types" },
    ];
    const [hoveredValue, setHoveredValue] = useState(null);
    const { watch } = useFormContext();
    const selectedValues = watch("output");
    return (React.createElement(CustomScroll, null,
        React.createElement("div", { className: "modal-grid" },
            React.createElement("div", { className: "modal-left-column" },
                React.createElement("h2", null, "Specify your file outputs"),
                React.createElement("p", null, "Indicate the file format(s) you require for your project, whether for design, construction, or operations"),
                React.createElement("div", { className: "radio-grid file-type-grid" }, OutputData.map((option, idx) => (React.createElement(CheckInput, { className: "form-check-input", id: `output-${idx}`, name: "output", label: option.key, key: idx, onHover: setHoveredValue })))),
                React.createElement(ErrorPanel, { name: "output" })),
            React.createElement("div", { className: "modal-right-column" },
                React.createElement("div", { className: "file-type-stack" },
                    OutputData.map((option, idx) => (React.createElement("img", { width: "700", height: "600", key: idx, src: `/assets/images/quote-modal/file-types/${option.name}.webp?v=6`, alt: option.description, className: clsx("img-fluid file-image right-col-image", {
                            "d-none": (selectedValues && !selectedValues.includes(option.key)) && hoveredValue !== option.key,
                        }), style: {
                            "filter": hoveredValue === option.key ? "hue-rotate(12deg) brightness(90%) saturate(200%)" : ""
                        }, loading: "lazy" }))),
                    React.createElement("img", { width: "700", height: "600", src: "/assets/images/quote-modal/file-types/base.webp?v=5", alt: "Parametrix Office Space", className: "img-fluid base-file right-col-image", loading: "lazy" }))))));
};
export default Step3;
